module.exports = __webpack_public_path__ + "static/media/job.e144f42f.svg";